export default __webpack_public_path__ + "static/media/AneomiClosed2.9f3f88e6.jpg";